import dateFnsService from 'shared/services/date-fns-service';
import {FilterQueryProps} from './encode-filters';
import {DateOperators} from 'shared/components/date-filter';

const getFilterValue = (date: Date) => ({
  date: dateFnsService.apiDateFormat(date),
  time: dateFnsService.timeFormat(date),
});

interface Props {
  startDate: Date;
  endDate?: Date;
  startDateField: string;
  endDateField?: string;
}

const encodeDateFilter = ({
  startDate,
  endDate = startDate,
  startDateField,
  endDateField = startDateField,
}: Props) => {
  const dateFilters: FilterQueryProps = {};

  const startDateFilter = {
    operator: DateOperators.GreaterThanEqual,
    value: getFilterValue(startDate),
  };

  const endDateFilter = {
    operator: DateOperators.LessThanEqual,
    value: getFilterValue(endDate),
  };

  if (startDateField === endDateField)
    // @ts-ignore
    dateFilters[startDateField] = JSON.stringify([
      startDateFilter,
      endDateFilter,
    ]);
  else {
    // @ts-ignore
    dateFilters[startDateField] = JSON.stringify([startDateFilter]);
    // @ts-ignore
    dateFilters[endDateField] = JSON.stringify([endDateFilter]);
  }

  return dateFilters;
};

export default encodeDateFilter;
